import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { connect } from "react-redux";

//ANT DESIGN IMPORTS
import {
  Input,
  Row,
  Card,
  Form,
  Select,
  Col,
  Divider,
  Spin,
  DatePicker,
  InputNumber,
  Checkbox,
  Tooltip,
  Button,
  Table,
  Typography,
} from "antd";

//PROJECT IMPORTS
import { BOM } from "../../../../../services/definedMethod";
import cnt from "../../../../../services/definedConstant";
import CustomButton from "../../../../../components/custom/CustomButton";
import { apiConfig, labelConfig, staticConfig } from "../../../customer.config";
import { accountStatus } from "../../../../../components/facilities/AccountFacility";
import styles from "../../../../../assets/styles/styles";
import dayjs from "dayjs";
import { showCheckerApprovalModal } from "../../../../../components/CheckerModal";
import DownloadTableButtons from "../../../../../components/layouts/enhancement/DownloadTableButtons";
import MainLayout from "../../../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../../../components/layouts/enhancement/TopContent";
const { Text, Title } = Typography;
const HoldItems = (props) => {
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();

  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [accountDetails, setAccountDetails] = useState();
  const holdItems = accountDetails?.liens ?? [];
  const columns = [
    {
      title: "ID",
      dataIndex: "id",
    },
    {
      title: "Account Number",
      dataIndex: "transactionDate",
      render: (_, record) => <Text>{accountDetails?.accountNo}</Text>,
    },
    {
      title: "Reason",
      dataIndex: "reason",
    },
    {
      title: "Date",

      render: (_, record) => {
        console.log(record);
        return <Text>{BOM.DateTime(record.lienDate, "only-date")}</Text>;
      },
    },
    {
      title: "Amount",
      dataIndex: "amount",
    },

    {
      title: "Actions",
      render: (_, record) => (
        <>
          {!record.released ? (
            <Button
              onClick={() => releaseAmount(record.id)}
              type="primary"
              shape="round"
              size="small"
              className="of-primaryBtnColor"
            >
              Release
            </Button>
          ) : (
            <Text>Amount Released</Text>
          )}
        </>
      ),
    },
  ];
  useEffect(() => {
    getDetailById();
  }, []);

  const getDetailById = (temp) => {
    const params = {
      associations: "all",
    };

    const url = `${apiConfig.savingsAccounts}/${state.id}`;

    let body = {
      session,
      params,
    };
    setIsLoading(true);

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        setAccountDetails(objDetail);

        /**
         * STOP LOADER
         */
        setIsLoading(false);
      }
    });
  };
  const releaseAmount = (id) => {
    const url = `${apiConfig.savingsAccounts}/${state.id}/transactions/${id}?command=releaseAmount`;

    let body = {
      session,
      method: "POST",
    };
    setIsLoading(true);

    /** FETCH ROLE */
    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, "Amount released successfully");
          getDetailById();

          /**
           * STOP LOADER
           */
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate("/savings-account-action", { state: { ...state } });
          setIsLoading(false);
        },
      }
    );
  };

  console.log(accountDetails, "accountDetails");
  return (
    <MainLayout isEnableRightSidebar={true} pageItems={staticConfig.holdItemsBreadcrumbItems}>
      <TopContent pageTitle={labelConfig.hold} createPageTitle={"Hold account"} />
      <Card
        style={{
          border: "1px solid #EAECF0",
          borderRadius: 20,
          padding: 0,
          marginTop: 12,
        }}
      >
        <Spin spinning={isLoading} size="large">
          <div className="treasury-bills-table-container">
            <Table
              className="bond-table"
              // rowSelection={{
              //   type: "checkbox",
              //   onChange: onSelectItemAction,
              //   hideSelectAll: true,
              // }}
              columns={columns}
              dataSource={holdItems}
              pagination={false}
            />
          </div>
        </Spin>
      </Card>
    </MainLayout>
  );
};

export default HoldItems;
